import { Button } from '@mui/material'
import { ButtonExProps } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext, useState } from 'react'

import { EthersContext, useAuction } from '../Contexts'
import MintDutchDialog from './MintDutchDialog'
import MintGeotokenDialog from './MintGeotokenDialog'

export interface MintButtonProps extends ButtonExProps {
  alwaysShow?: boolean
  quadkey?: Quadkey
}

export const MintButton: React.FC<MintButtonProps> = ({ alwaysShow, quadkey, ...props }) => {
  const { localAddress } = useContext(EthersContext)
  const { auction } = useAuction(quadkey)

  const [mintDialogOpen, setMintDialogOpen] = useState(false)
  const [mintDutchDialogOpen, setMintDutchDialogOpen] = useState(false)

  const canMint = localAddress && auction?.canMint(localAddress)
  const canMintDutch = localAddress && auction?.isDutch()
  const show = alwaysShow || auction?.isCompleted() || auction?.isDutch()

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (canMint) {
      setMintDialogOpen(true)
    } else if (canMintDutch) {
      setMintDutchDialogOpen(true)
    }
  }

  const onClose = () => {
    setMintDialogOpen(false)
    setMintDutchDialogOpen(false)
  }

  return show ? (
    <>
      <Button color="primary" disabled={!canMint && !canMintDutch} onClick={onClick} variant="contained" {...props}>
        Mint
      </Button>
      <MintGeotokenDialog onClose={onClose} open={mintDialogOpen} quadkey={quadkey} />
      <MintDutchDialog onClose={onClose} open={mintDutchDialogOpen} quadkey={quadkey} />
    </>
  ) : null
}
